export var ReportType = /*#__PURE__*/ function(ReportType) {
    ReportType["Pivot"] = "PIVOT";
    ReportType["Tabular"] = "TABULAR";
    return ReportType;
}({});
export var ReportingSourceType = /*#__PURE__*/ function(ReportingSourceType) {
    ReportingSourceType["Project"] = "PROJECT";
    ReportingSourceType["Task"] = "TASK";
    ReportingSourceType["User"] = "USER";
    ReportingSourceType["TimeTracking"] = "TIME_TRACKING";
    ReportingSourceType["Role"] = "ROLE";
    ReportingSourceType["Phase"] = "PHASE";
    ReportingSourceType["Company"] = "COMPANY";
    ReportingSourceType["Form"] = "FORM";
    ReportingSourceType["ProjectFinancialBudget"] = "PROJECT_FINANCIAL_BUDGET";
    return ReportingSourceType;
}({});
export var AggregateType = /*#__PURE__*/ function(AggregateType) {
    AggregateType["Average"] = "AVG";
    AggregateType["Total"] = "SUM";
    AggregateType["Count"] = "COUNT";
    AggregateType["None"] = "NONE";
    return AggregateType;
}({});
export var DateType = /*#__PURE__*/ function(DateType) {
    DateType["Day"] = "DAY";
    DateType["Week"] = "WEEK";
    DateType["Month"] = "MONTH";
    DateType["Quarter"] = "QUARTER";
    DateType["Year"] = "YEAR";
    return DateType;
}({});
export var ZoomLevel = /*#__PURE__*/ function(ZoomLevel) {
    ZoomLevel["Daily"] = "DAY";
    ZoomLevel["Weekly"] = "WEEK";
    ZoomLevel["Monthly"] = "MONTH";
    ZoomLevel["Yearly"] = "YEAR";
    ZoomLevel["Quarterly"] = "QUARTER";
    return ZoomLevel;
}({});
export var FieldClass = /*#__PURE__*/ function(FieldClass) {
    FieldClass["NativeField"] = "NATIVE";
    FieldClass["CustomField"] = "CUSTOM";
    FieldClass["DefaultField"] = "DEFAULT";
    return FieldClass;
}({});
export var FieldOptionType = /*#__PURE__*/ function(FieldOptionType) {
    FieldOptionType["SingleSelect"] = "SINGLE_SELECT";
    FieldOptionType["MultiSelect"] = "MULTI_SELECT";
    FieldOptionType["Rating"] = "RATING";
    FieldOptionType["KeyEvents"] = "KEY_EVENTS";
    FieldOptionType["Intervals"] = "INTERVALS";
    FieldOptionType["Formula"] = "FORMULA";
    return FieldOptionType;
}({});
// The star-schema (time-entry mart) sources a report field can come from, as
// carried on a column's sourceType alongside the CustomReportsFieldGroups
// values.
export var StarMetaSourceType = /*#__PURE__*/ function(StarMetaSourceType) {
    StarMetaSourceType["StarMeta"] = "STAR_META";
    StarMetaSourceType["EstimatedStarMeta"] = "ESTIMATED_STAR_META";
    StarMetaSourceType["ActualStarMeta"] = "ACTUAL_STAR_META";
    return StarMetaSourceType;
}({});
export var CustomReportsFieldGroups = /*#__PURE__*/ function(CustomReportsFieldGroups) {
    CustomReportsFieldGroups["Task"] = "TASK";
    CustomReportsFieldGroups["Project"] = "PROJECT";
    CustomReportsFieldGroups["Role"] = "ROLE";
    CustomReportsFieldGroups["User"] = "USER";
    CustomReportsFieldGroups["Partners"] = "PARTNERS";
    CustomReportsFieldGroups["Allocations"] = "ALLOCATIONS";
    CustomReportsFieldGroups["TimeTracking"] = "TIME_TRACKING";
    CustomReportsFieldGroups["Financials"] = "FINANCIALS";
    CustomReportsFieldGroups["BudgetFinancials"] = "BUDGET_FINANCIALS";
    CustomReportsFieldGroups["Phase"] = "PHASE";
    CustomReportsFieldGroups["FormulaFields"] = "FORMULA_FIELDS";
    CustomReportsFieldGroups["Company"] = "COMPANY";
    CustomReportsFieldGroups["Form"] = "FORM";
    CustomReportsFieldGroups["Budget"] = "PROJECT_FINANCIAL_BUDGET";
    return CustomReportsFieldGroups;
}({});
export var SortOrderType = /*#__PURE__*/ function(SortOrderType) {
    SortOrderType["Asc"] = "ASC";
    SortOrderType["Desc"] = "DESC";
    return SortOrderType;
}({});
export const toAgGridSortOrder = (sortOrder)=>sortOrder.toLowerCase();
export var VisibilityScopeType = /*#__PURE__*/ function(VisibilityScopeType) {
    VisibilityScopeType["Everyone"] = "everyone";
    VisibilityScopeType["Self"] = "self";
    VisibilityScopeType["Limited"] = "limited";
    return VisibilityScopeType;
}({});
export var CustomReportVisibilityScopeType = /*#__PURE__*/ function(CustomReportVisibilityScopeType) {
    CustomReportVisibilityScopeType["Everyone"] = "EVERYONE";
    CustomReportVisibilityScopeType["Self"] = "SELF";
    CustomReportVisibilityScopeType["Members"] = "MEMBERS";
    CustomReportVisibilityScopeType["Group"] = "GROUP";
    return CustomReportVisibilityScopeType;
}({});
export const ColorPallete = [
    {
        name: 'Green50',
        value: 'var(--green-50)'
    },
    {
        name: 'Green40',
        value: 'var(--green-40)'
    },
    {
        name: 'GreenSingle40',
        value: 'var(--green-40)'
    },
    {
        name: 'GreenMulti40',
        value: 'var(--green-40)'
    },
    {
        name: 'Green30',
        value: 'var(--green-30)'
    },
    {
        name: 'Green20',
        value: 'var(--green-20)'
    },
    {
        name: 'GreenSingle20',
        value: 'var(--green-20)'
    },
    {
        name: 'GreenMulti20',
        value: 'var(--green-20)'
    },
    {
        name: 'Yellow50',
        value: 'var(--yellow-50)'
    },
    {
        name: 'YellowSingle50',
        value: 'var(--yellow-50)'
    },
    {
        name: 'YellowMulti50',
        value: 'var(--yellow-50)'
    },
    {
        name: 'Yellow40',
        value: 'var(--yellow-40)'
    },
    {
        name: 'Yellow30',
        value: 'var(--yellow-30)'
    },
    {
        name: 'YellowSingle30',
        value: 'var(--yellow-30)'
    },
    {
        name: 'YellowMulti30',
        value: 'var(--yellow-30)'
    },
    {
        name: 'Yellow20',
        value: 'var(--yellow-20)'
    },
    {
        name: 'Red50',
        value: 'var(--red-50)'
    },
    {
        name: 'Red40',
        value: 'var(--red-40)'
    },
    {
        name: 'RedSingle40',
        value: 'var(--red-40)'
    },
    {
        name: 'RedMulti40',
        value: 'var(--red-40)'
    },
    {
        name: 'Red30',
        value: 'var(--red-30)'
    },
    {
        name: 'Red20',
        value: 'var(--red-20)'
    },
    {
        name: 'RedSingle20',
        value: 'var(--red-20)'
    },
    {
        name: 'RedMulti20',
        value: 'var(--red-20)'
    }
];
export const MultiColorPallete = [
    {
        name: 'GreenMulti40',
        value: 'var(--green-40)'
    },
    {
        name: 'GreenMulti20',
        value: 'var(--green-20)'
    },
    {
        name: 'YellowMulti30',
        value: 'var(--yellow-30)'
    },
    {
        name: 'YellowMulti50',
        value: 'var(--yellow-50)'
    },
    {
        name: 'RedMulti20',
        value: 'var(--red-20)'
    },
    {
        name: 'RedMulti40',
        value: 'var(--red-40)'
    }
];
export const SingleColorPalletes = [
    [
        {
            name: 'Green20',
            value: 'var(--green-20)'
        },
        {
            name: 'Green30',
            value: 'var(--green-30)'
        },
        {
            name: 'Green40',
            value: 'var(--green-40)'
        },
        {
            name: 'Green50',
            value: 'var(--green-50)'
        }
    ],
    [
        {
            name: 'Yellow20',
            value: 'var(--yellow-20)'
        },
        {
            name: 'Yellow30',
            value: 'var(--yellow-30)'
        },
        {
            name: 'Yellow40',
            value: 'var(--yellow-40)'
        },
        {
            name: 'Yellow50',
            value: 'var(--yellow-50)'
        }
    ],
    [
        {
            name: 'Red20',
            value: 'var(--red-20)'
        },
        {
            name: 'Red30',
            value: 'var(--red-30)'
        },
        {
            name: 'Red40',
            value: 'var(--red-40)'
        },
        {
            name: 'Red50',
            value: 'var(--red-50)'
        }
    ]
];
export var HighlightingType = /*#__PURE__*/ function(HighlightingType) {
    HighlightingType["SingleColor"] = "SINGLE_COLOR";
    HighlightingType["MultiColor"] = "MULTI_COLOR";
    return HighlightingType;
}({});
export var HighlightingSingleColorConditionType = /*#__PURE__*/ function(HighlightingSingleColorConditionType) {
    HighlightingSingleColorConditionType["GreaterThan"] = "GREATER_THAN";
    HighlightingSingleColorConditionType["Equals"] = "EQUALS";
    HighlightingSingleColorConditionType["LesserThan"] = "LESSER_THAN";
    return HighlightingSingleColorConditionType;
}({});
export var HighlightingMultiColorType = /*#__PURE__*/ function(HighlightingMultiColorType) {
    HighlightingMultiColorType["Smart"] = "SMART";
    HighlightingMultiColorType["Custom"] = "CUSTOM";
    return HighlightingMultiColorType;
}({});
export var WidgetType = /*#__PURE__*/ function(WidgetType) {
    WidgetType["CustomCard"] = "CUSTOM_CARD";
    WidgetType["CustomChart"] = "CUSTOM_CHART";
    WidgetType["CustomTable"] = "CUSTOM_TABLE";
    return WidgetType;
}({});
export var WidgetTypes = /*#__PURE__*/ function(WidgetTypes) {
    WidgetTypes["Resolve"] = "RESOLVE";
    WidgetTypes["Preview"] = "PREVIEW";
    return WidgetTypes;
}({});
export var SortType = /*#__PURE__*/ function(SortType) {
    SortType["Default"] = "";
    SortType["Asc"] = "ASC";
    SortType["Desc"] = "DESC";
    return SortType;
}({});
export const NumberWidgetTypes = [
    "CUSTOM_CARD"
];
export var WidgetDefaultNumberFields = /*#__PURE__*/ function(WidgetDefaultNumberFields) {
    WidgetDefaultNumberFields["ProjectCount"] = "projectCount";
    WidgetDefaultNumberFields["CustomerCount"] = "companyCount";
    WidgetDefaultNumberFields["CSAT"] = "csat";
    WidgetDefaultNumberFields["TaskCount"] = "taskCount";
    WidgetDefaultNumberFields["CsatRating"] = "csatRating";
    WidgetDefaultNumberFields["UserCount"] = "userCount";
    WidgetDefaultNumberFields["SubmissionCount"] = "submissionCount";
    WidgetDefaultNumberFields["BudgetCount"] = "budgetCount";
    return WidgetDefaultNumberFields;
}({});
export var WidgetNativeNumberFields = /*#__PURE__*/ function(WidgetNativeNumberFields) {
    WidgetNativeNumberFields["ARR"] = "annualizedRecurringRevenue";
    WidgetNativeNumberFields["ProjectFee"] = "projectFee";
    return WidgetNativeNumberFields;
}({});
export var WidgetNativeValues = /*#__PURE__*/ function(WidgetNativeValues) {
    WidgetNativeValues["ARR"] = "annualizedRecurringRevenue";
    WidgetNativeValues["ProjectFee"] = "projectFee";
    WidgetNativeValues["ProjectBudget"] = "projectBudget";
    WidgetNativeValues["Effort"] = "effort";
    WidgetNativeValues["CostRate"] = "costRate";
    WidgetNativeValues["TrackedMinutes"] = "trackedMinutes";
    WidgetNativeValues["StartDate"] = "startDate";
    WidgetNativeValues["CreatedDate"] = "date";
    WidgetNativeValues["UserStaus"] = "userStatus";
    WidgetNativeValues["UsedByPartners"] = "usedByPartners";
    WidgetNativeValues["CapacityMinutes"] = "capacityMinutes";
    WidgetNativeValues["CompanyName"] = "companyName";
    return WidgetNativeValues;
}({});
export var UnitPosition = /*#__PURE__*/ function(UnitPosition) {
    UnitPosition["Prefix"] = "PREFIX";
    UnitPosition["Suffix"] = "SUFFIX";
    return UnitPosition;
}({});
export var FieldUnit = /*#__PURE__*/ function(FieldUnit) {
    FieldUnit["Hours"] = "HOURS";
    FieldUnit["Currency"] = "CURRENCY";
    FieldUnit["Percentage"] = "PERCENTAGE";
    FieldUnit["Number"] = "NUMBER";
    return FieldUnit;
}({});
export var VerticalAxisDefaultTaskFields = /*#__PURE__*/ function(VerticalAxisDefaultTaskFields) {
    VerticalAxisDefaultTaskFields["TaskCount"] = "count";
    VerticalAxisDefaultTaskFields["TaskCSAT"] = "csat";
    VerticalAxisDefaultTaskFields["TaskTrackedMinutes"] = "trackedMinutes";
    VerticalAxisDefaultTaskFields["TaskEffort"] = "effort";
    VerticalAxisDefaultTaskFields["TaskProgress"] = "progress";
    return VerticalAxisDefaultTaskFields;
}({});
export var VerticalAxisDefaultProjectFields = /*#__PURE__*/ function(VerticalAxisDefaultProjectFields) {
    VerticalAxisDefaultProjectFields["ProjectCount"] = "count";
    VerticalAxisDefaultProjectFields["CSAT"] = "csat";
    VerticalAxisDefaultProjectFields["ProjectBugetedHours"] = "budgetedHours";
    VerticalAxisDefaultProjectFields["ProjectTrackedMinutes"] = "trackedMinutes";
    VerticalAxisDefaultProjectFields["ProjectAge"] = "projectAge";
    return VerticalAxisDefaultProjectFields;
}({});
export var HorizontalAxisDefaultTaskFields = /*#__PURE__*/ function(HorizontalAxisDefaultTaskFields) {
    HorizontalAxisDefaultTaskFields["TaskStartDate"] = "startDate";
    HorizontalAxisDefaultTaskFields["TaskDueDate"] = "dueDate";
    HorizontalAxisDefaultTaskFields["TaskActualStartDate"] = "actualStartDate";
    HorizontalAxisDefaultTaskFields["TaskActualDueDate"] = "actualDueDate";
    HorizontalAxisDefaultTaskFields["TaskStatus"] = "status";
    HorizontalAxisDefaultTaskFields["TaskAssignee"] = "taskAssignee";
    return HorizontalAxisDefaultTaskFields;
}({});
export var HorizontalAxisDefaultProjectFields = /*#__PURE__*/ function(HorizontalAxisDefaultProjectFields) {
    HorizontalAxisDefaultProjectFields["ProjectStatus"] = "status";
    HorizontalAxisDefaultProjectFields["Templates"] = "template";
    HorizontalAxisDefaultProjectFields["ProjectCreatedDate"] = "createdDate";
    HorizontalAxisDefaultProjectFields["ProjectStartDate"] = "startDate";
    HorizontalAxisDefaultProjectFields["ProjectDueDate"] = "dueDate";
    HorizontalAxisDefaultProjectFields["ActualProjectStartDate"] = "actualStartDate";
    HorizontalAxisDefaultProjectFields["ActualProjectCompletionDate"] = "actualDueDate";
    HorizontalAxisDefaultProjectFields["ProjectOwner"] = "projectOwner";
    return HorizontalAxisDefaultProjectFields;
}({});
export var ChartStackingType = /*#__PURE__*/ function(ChartStackingType) {
    ChartStackingType["Normal"] = "normal";
    ChartStackingType["Percent"] = "percent";
    return ChartStackingType;
}({});
export const NativeDateFields = [
    "createdDate",
    "startDate",
    "dueDate",
    "actualStartDate",
    "actualDueDate",
    "dueDate",
    "startDate",
    "actualDueDate",
    "actualStartDate"
];
export const excludedTaskFieldsForCustomChart = [
    'priority'
];
export var GroupByDefaultProjectFields = /*#__PURE__*/ function(GroupByDefaultProjectFields) {
    GroupByDefaultProjectFields["ProjectOwner"] = "projectOwner";
    GroupByDefaultProjectFields["ProjectStatus"] = "status";
    return GroupByDefaultProjectFields;
}({});
export var GroupByDefaultTaskFields = /*#__PURE__*/ function(GroupByDefaultTaskFields) {
    GroupByDefaultTaskFields["TaskStatus"] = "status";
    return GroupByDefaultTaskFields;
}({});
export var DrillDownExportType = /*#__PURE__*/ function(DrillDownExportType) {
    DrillDownExportType["PROJECT"] = "PROJECT";
    DrillDownExportType["TASK"] = "TASK";
    return DrillDownExportType;
}({});
